import ProdutividadeService from "./ProdutividadeService";

export default {
  mixins: [ProdutividadeService],
  methods: {
    downloadHandler(payload) {
      this.$store.commit("setLoadingModal", true);
      this.downloadProdutividade(payload)
        .then(res => {
          if (res.status === 204) return;
          this.$helpers.baixarArquivo(
            res.data,
            res.headers["content-disposition"]
          );
        })
        .finally(() => {
          this.$store.commit("setLoadingModal", false);
        });
    }
  }
};
